import React from 'react';
import {
  Switch, BrowserRouter as Router,
} from 'react-router-dom';
import { createBrowserHistory } from 'history';
// Componetes de ruta
import SignIn from 'views/auth/signIn/SignIn';
import KeycloackInterceptor from 'views/auth/keycloackInterceptor/KeycloackInterceptor';
import { PublicRoutes } from './PublicRoutes';
import { PrivateRoute } from './PrivateRoutes';
import { NavigationRoutes } from './NavigationRoutes';

export const AppRouter = () => {
  const history = createBrowserHistory();

  return (
    <Router history={history}>
      <div>
        <Switch>
          <PublicRoutes exact path="/apiv1/sign-in" component={SignIn} />
          <PublicRoutes exact path="/apiv1/keycloackLogin" component={KeycloackInterceptor} />
          <PrivateRoute path="/" component={NavigationRoutes} />
        </Switch>
      </div>
    </Router>
  );
};
